import renderMenu from '../../../frontend/scripts/common/components/FFMenuV2/FFMenu';

const win = window as any;
if (!win.hideMenu) {
    renderMenu(win.activeMenu, {
        ffmenuBuildVersion: '1',
        currentUser: win.currentUser,
        featureFlags: win.featureFlags,
        notifications: win.notifications,
        serverEnv: win.serverEnv,
        initialize: {
            initializedState: win.initializedNavMenuState,
            navMenuSizeLocked: win.navMenuSizeLocked,
        },
    });
}
